import { LayoutWithSidebar } from 'utils/router/components/LayoutWithSidebar/LayoutWithSidebar'
import { getHandle } from 'utils/router/utils/getHandle'

export const MarketingMessageTemplatesAnalyticsRoutes = [
  {
    path: 'marketing-message-templates-analytics',
    alias: 'marketingMessageTemplatesAnalytics',
    handle: getHandle('marketing_message_templates_analytics'),
    Component: LayoutWithSidebar,
    children: [
      {
        index: true,
        lazy: () => import('./AggregatedAnalytics.page'),
      },
      {
        path: ':template_id',
        alias: 'marketingMessageTemplate',
        lazy: () => import('./MarketingMessageTemplate.page'),
      },
    ],
  },
] as const
